import { View, Page, Text, StyleSheet } from "@react-pdf/renderer";
import { ImageComponent } from "./ImageComponent";
import HeaderWasteQualityPDF from "./HeaderWasteQualityPDF";
import { WasteQualityLegend } from "./WasteQualityLegend";
import { WasteQualityFooter } from "./WasteQualityFooter";
import { formatLocalCaptureTimestamp } from "../../formatted/FormattedDateAndTime";

const styles = StyleSheet.create({
  content: {
    display: "flex",
    flexDirection: "row",
    padding: 20,
    height: "79%",
    backgroundColor: "#FFFFFF",
  },
  imagesColumn: {
    flex: 7.7,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  captureTimestamp: {
    alignSelf: "flex-start",
    fontSize: 11,
    color: "#6B7280",
    marginBottom: 6,
    fontFamily: "Mulish",
  },
  legendColumn: {
    flex: 2.3,
  },
});

export const WasteQualityImageComponent = ({
  data,
  page,
  caracDatetime,
  logoUrl,
}) => {
  const captureTimestamp = formatLocalCaptureTimestamp(
    data?._time || data?.time,
  );

  return (
    <Page size="A4">
      <HeaderWasteQualityPDF caracDatetime={caracDatetime} logoUrl={logoUrl} />
      <View style={styles.content}>
        <View style={styles.imagesColumn}>
          {captureTimestamp ? (
            <Text style={styles.captureTimestamp}>{captureTimestamp}</Text>
          ) : null}
          <ImageComponent data={data} drawMaterial={true} />
          <ImageComponent data={data} drawMaterial={false} />
        </View>
        <View style={styles.legendColumn}>
          <WasteQualityLegend data={data} />
        </View>
      </View>
      <WasteQualityFooter page={page} />
    </Page>
  );
};
